module.exports = __webpack_public_path__ + "img/download_select.f7f80783.png";